import { BudgetBys, BudgetPhases, BudgetSections } from 'business/constants';
import { createContext } from 'react';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';

// Create a default budget proposal to avoid typing the Context as BudgetProposalT | undefined
const dummyBudgetProposal: BudgetProposalT = {
    budgetName: 'DUMMY BP 123 AZERTY WE SHOULD NEVER MATCH THIS NAME IRL',
    by: BudgetBys.ORG_CHART_FINANCE,
    cadrageByChapter: false,
    exercice: 0,
    id: 99999999999999,
    name: '',
    phase: BudgetPhases.ARBITRAGE,
    section: BudgetSections.OPERATING,
    canResourceEdit: [],
    projectionBy: [],
    pluriannualProjectionBy: [],
};
export const CurrentBudgetProposalContext = createContext(dummyBudgetProposal);

/**
 * Assert that the budget proposal is not the dummy default one
 */
export const isLegitBudgetProposal = (
    budgetProposal: BudgetProposalT | undefined,
): budgetProposal is BudgetProposalT =>
    Boolean(
        budgetProposal &&
            budgetProposal.budgetName !== dummyBudgetProposal.budgetName,
    );
